module.exports = __webpack_public_path__ + "media/images/technology/MGISEQ-200-3f6e993a406bcda0bee212ba7bea4e40.png";